// extracted by mini-css-extract-plugin
export default {"team-skills":"styles_team-skills__-tWox","team-skills-title":"styles_team-skills-title__CglF2","team-skills-descriptor":"styles_team-skills-descriptor__UpPcS"};